import { FilterBoxes } from 'src/models/filter';

import { Callback } from 'src/util/query/models/Callback';

import { IdoActivityHistoryListCallbackStoreContract } from '../interfaces';

export class GetTheIdoActivityModuleBoxesForTheIdoCallBack extends Callback<Array<FilterBoxes>> {
	public constructor(
		private readonly store: IdoActivityHistoryListCallbackStoreContract,
		private readonly uniqueListIdentifier: string,
		private readonly aggregateId: string
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Array<FilterBoxes>): void => {
		this.store.setFilterBoxesValue({
			aggregateId: this.aggregateId,
			payload: successResponse.filter((filterBox) => filterBox.isVirtual === false),
			uniqueListIdentifier: this.uniqueListIdentifier,
		});
	};
}
